/* Krevalo Tekla — header/marquee/drawer/FAQ interactions.
   Guarded: every handler bails if its target is absent, so this is safe to load
   site-wide alongside the vendor theme JS. No cart store here — the real Shopify
   cart/search/account links are used directly. Ported behaviours from
   theme-mockups/tekla/_live-reference/assets__shell.js + assets__krevalo.js. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // --- Sticky header scroll state (.scrolled adds blur + border) ---
  function setupStickyHeader() {
    var header = document.querySelector('.krv-header');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- FAQ accordion (aria-expanded + .open toggle + hidden in lockstep) ---
  function setupFAQ() {
    var qs = document.querySelectorAll('.krv-tekla .faq-q');
    qs.forEach(function (btn, idx) {
      var item = btn.closest('.faq-item');
      if (!item) return;
      var answer = item.querySelector('.faq-a');
      if (answer && !answer.id) { answer.id = 'krv-faq-a-' + idx; }
      if (answer && !btn.getAttribute('aria-controls')) { btn.setAttribute('aria-controls', answer.id); }
      var open = item.classList.contains('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (answer) { answer.hidden = !open; }
      btn.addEventListener('click', function () {
        var nowOpen = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
        if (answer) { answer.hidden = !nowOpen; }
      });
    });
  }

  // --- Buy-box detail tabs (horizontal, single-select; replaces the buy-box accordion) ---
  function setupPdpTabs() {
    document.querySelectorAll('[data-pdp-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.pdp-tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.pdp-tabpanel'));
      if (!tabs.length) return;
      function select(idx) {
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, i) { p.hidden = i !== idx; });
      }
      var initial = 0;
      tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') initial = i; });
      select(initial);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
          if (!dir) return;
          e.preventDefault();
          var next = (i + dir + tabs.length) % tabs.length;
          tabs[next].focus(); select(next);
        });
      });
    });
  }

  // --- Mega menu: hover + focus, panel keyed by data-mega="panel-id" ---
  function setupMegaMenu() {
    var triggers = document.querySelectorAll('.krv-header [data-mega]');
    if (!triggers.length) return;
    var allMenus = document.querySelectorAll('.krv-header .mega-menu');
    var timeout;
    var closeAll = function () {
      allMenus.forEach(function (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    };
    triggers.forEach(function (t) {
      var id = t.dataset.mega;
      var menu = document.getElementById(id);
      if (!menu) return;
      t.setAttribute('aria-expanded', 'false');
      t.setAttribute('aria-controls', id);
      var open = function () {
        clearTimeout(timeout);
        closeAll();
        menu.classList.add('open');
        menu.setAttribute('aria-hidden', 'false');
        t.setAttribute('aria-expanded', 'true');
      };
      t.addEventListener('mouseenter', open);
      t.addEventListener('focus', open);
      t.addEventListener('mouseleave', function () {
        timeout = setTimeout(closeAll, 200);
      });
      menu.addEventListener('mouseenter', function () { clearTimeout(timeout); });
      menu.addEventListener('mouseleave', closeAll);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  // --- Mobile nav drawer (hamburger) ---
  function setupMobileDrawer() {
    var toggle = document.querySelector('[data-krv-nav-toggle]');
    var drawer = document.querySelector('.krv-mobile-drawer');
    var overlay = document.querySelector('.krv-mobile-overlay');
    if (!toggle || !drawer) return;
    var savedScroll = 0;
    var close = function () {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      // Release the body scroll lock and restore the exact prior scroll position.
      document.body.classList.remove('krv-drawer-open');
      document.body.style.top = '';
      window.scrollTo(0, savedScroll);
    };
    var open = function () {
      // Lock the body at the current scroll. overflow:hidden alone does NOT stop touch
      // scrolling on mobile (the page kept scrolling behind the menu); position:fixed does.
      savedScroll = window.scrollY || window.pageYOffset || 0;
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.top = '-' + savedScroll + 'px';
      document.body.classList.add('krv-drawer-open');
    };
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('open')) close(); else open();
    });
    if (overlay) overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-krv-nav-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Collapsible submenus inside the mobile drawer
    drawer.querySelectorAll('[data-krv-submenu-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.closest('.krv-mdrawer-item');
        if (li) {
          var isOpen = li.classList.toggle('open');
          b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      });
    });
  }

  // --- Footer link columns: collapse to + accordions on phones (<=599); open + static above that ---
  function setupFooterAccordion() {
    var toggles = document.querySelectorAll('.footer-col-toggle');
    if (!toggles.length) return;
    var mq = window.matchMedia('(max-width: 599px)');
    function sync() {
      toggles.forEach(function (btn) {
        if (!mq.matches) {
          // Desktop/tablet: columns are always open and the toggle is inert — a plain
          // heading button, not an expander — so drop the (mismatched) aria-expanded.
          btn.removeAttribute('aria-expanded');
        } else {
          var col = btn.closest('.footer-col');
          btn.setAttribute('aria-expanded', col && col.classList.contains('is-open') ? 'true' : 'false');
        }
      });
    }
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mq.matches) return; // desktop/tablet: columns are always open, toggle is inert
        var col = btn.closest('.footer-col');
        if (!col) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    sync();
  }

  // Desktop cart aside ("you might also like" side column). It lives OUTSIDE
  // #minicart-form, so the AJAX add/change re-render never touches it — on a cart that
  // started empty it would otherwise stay empty/hidden. Re-point it at the current first
  // product and re-fetch each time the drawer opens.
  function setupCartAside() {
    var aside = document.querySelector('.krv-cart-aside');
    if (!aside) return;
    var tmpl = aside.getAttribute('data-rec-base');
    var wrap = aside.querySelector('.swiper-wrapper');
    if (!tmpl || !wrap) return;
    function sync() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) { aside.classList.add('hidden'); return null; }
          var pid = String(cart.items[0].product_id);
          if (aside.getAttribute('data-loaded-pid') === pid) { aside.classList.remove('hidden'); return null; }
          return fetch(tmpl.replace('__PID__', pid)).then(function (res) {
            if (!res.ok) { aside.classList.add('hidden'); return; }
            return res.text().then(function (html) {
              var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.swiper-wrapper');
              if (src && src.innerHTML.trim()) {
                wrap.innerHTML = src.innerHTML;
                aside.setAttribute('data-loaded-pid', pid);
                aside.classList.remove('hidden');
                if (window.BlsLazyloadImg) BlsLazyloadImg.init();
              } else {
                aside.classList.add('hidden');
              }
            });
          });
        })
        .catch(function () {});
    }
    sync(); // populate on load when the cart already has items
    new MutationObserver(function () {
      if (document.documentElement.classList.contains('open-drawer')) sync();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  // --- Filter "Clear All" keyboard operability (vendor <facet-clear-all> binds click only) ---
  function setupFilterClearAllKeyboard() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var t = e.target;
      if (t && t.matches && t.matches('facet-clear-all[role="button"]')) {
        e.preventDefault();
        t.click();
      }
    });
  }

  ready(function () {
    setupStickyHeader();
    setupFAQ();
    setupPdpTabs();
    setupMegaMenu();
    setupMobileDrawer();
    setupFooterAccordion();
    setupCartAside();
    setupFilterClearAllKeyboard();
  });
})();
